<template>
	<div class="form-container">
		<h2 class="form-title">비밀번호 재확인</h2>

		<form @submit.prevent="onSubmitForm">
			<div class="form-group">
				<label class="form-label">현재 비밀번호</label>
				<input
					v-model="currentPassword"
					class="form-input"
					type="password"
					placeholder="현재 비밀번호를 입력하세요"
				/>
			</div>

			<div class="form-group form-button">
				<Btn type="submit" color="primary" medium block>다음</Btn>
			</div>
		</form>
	</div>
</template>

<script>
import mixin from '@/mixins/mixin';
import { checkPassword } from '@/api';

import Btn from '@/components/common/Btn';

export default {
	mixins: [mixin],
	components: {
		Btn,
	},
	data() {
		return {
			currentPassword: '',
		};
	},
	methods: {
		async onSubmitForm() {
			const params = {
				userId: this.$store.state.userStore.user.user_id,
				currentPassword: this.currentPassword,
			};

			const { data } = await checkPassword(params);

			if (data.code === '00000') {
				{
					// 다음 단계
					const nextStep = this.$parent.step + 1;
					this.$emit('changeStep', nextStep);
				}
			} else {
				const message = data.message;
				const options = {
					message,
				};
				this.showAlert(options);
			}
		},
	},
};
</script>
